module.exports = __webpack_public_path__ + "img/0-63.efa1ee21.jpg";